export * from './defaultTranslations';

export const APP_NAME = 'loyalty-dialog';

export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;

export const IDENTITY_CLIENT_ID = 'SPADev';
